/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import { Util } from "@common/util";
import { TargetEnum } from "ecv/common/permissions";

export class SendInviteController {

    static $inject = ["$q", "$rootScope", "$uibModalStack", "$scope", "$injector",
        "$uibModalInstance", "PopUpService", "CacheService", "subject", "user", "popupMessage",
        "title", "inviteCancelInfo", "isQuickPopUp", "UtilityService", "CommonService"];

    constructor(
        $q,
        $rootScope,
        $uibModalStack,
        $scope,
        private $injector,
        private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
        private PopUpService,
        private CacheService,
        subject,
        user,
        popupMessage,
        title,
        inviteCancelInfo,
        isQuickPopUp,
        private UtilityService,
        private CommonService
    ) {
        var $validationProvider = $injector.get('$validation');
        $rootScope.mainShowLoader = false;
        var sendInviteVm: any = this;
        sendInviteVm.emailAddress = null;
        sendInviteVm.subject = subject
        sendInviteVm.user = user;
        sendInviteVm.popupMessage = popupMessage;
        sendInviteVm.title = title;
        sendInviteVm.personalMsg = "";
        sendInviteVm.isCommentBlank = false;
        sendInviteVm.loginUserId = CacheService.getUser().userId;
        sendInviteVm.loginUserTypeId = CacheService.getUser().userTypeId;
        sendInviteVm.do_it_later = Util.DO_IT_LATER;
        sendInviteVm.send_invite = Util.SEND_INVITE;
        sendInviteVm.sendInviteWithCoCaptain = false;
        sendInviteVm.inviteCancelInfo = inviteCancelInfo;
        sendInviteVm.isQuickPopUp = isQuickPopUp;
        sendInviteVm.checkAccessForTeamMemmber = {
            partyId: subject.teamPartyId,
            target: TargetEnum.TEAMMEMBER
        }


        CommonService.setIsMobile();
        window.addEventListener('resize', CommonService.setIsMobile);
        $scope.$on("$destroy", function () {
            window.removeEventListener('resize', CommonService.setIsMobile);
        });
        sendInviteVm.openCommentBox = function () {
            var editor = document.getElementById('message-editor');
            var commentBox = document.getElementById('message');
            commentBox.style.display = "none";
            editor.style.display = "block";
            angular.element('.ql-editor').focus();
        }

        sendInviteVm.toggleLabelColor = function (editor, range, oldRange, source) {
            var msgLbl = document.getElementById('msgLbl');
            if (range) {
                msgLbl.style.color = Util.COLORS.ecvBlue;
            } else {
                msgLbl.style.color = Util.COLORS.lightText;
            }
        }

        sendInviteVm.editorCreated = (editor) => {
            UtilityService.setURLPlaceholder(editor);
        }

        sendInviteVm.contentChanged = function (editor, html, text, content) {
            if (text.trim() == "") {
                sendInviteVm.isCommentBlank = true;
            } else {
                sendInviteVm.isCommentBlank = false;
            }
        }

        sendInviteVm.sendInvite = function (form) {
            var deferred = $q.defer();
            sendInviteVm.validating = true;
            $validationProvider.validate(form)
                .success(() => {
                    if (sendInviteVm.user.providerIdentity == null) {
                        if (sendInviteVm.emailAddress != null || sendInviteVm.emailAddress != '') {
                            sendInviteVm.user.providerIdentity = sendInviteVm.emailAddress;
                        }
                    }

                    if (sendInviteVm.sendInviteWithCoCaptain) {
                        sendInviteVm.user.coCaptain = true;
                    } else {
                        sendInviteVm.user.coCaptain = false;
                    }
                    if (!sendInviteVm.isCommentBlank) {
                        var filtered = sendInviteVm.personalMsg.replace(/href=/gi, "style='color:orange !important;' href=");
                        filtered = filtered.replace(/[&]nbsp[;]/gi, ""); // removes all occurrences of &nbsp;
                        filtered = filtered.replace(/[<]br[^>]*[>]/gi, "");
                        filtered = filtered.replace(/\t/g, '&#9;'),
                            filtered = filtered.replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi, "");
                        filtered = filtered.trim();
                    } else {
                        sendInviteVm.personalMsg = null;
                    }
                    $uibModalInstance.close({
                        "user": sendInviteVm.user,
                        "message": filtered,
                        "coCaptain": sendInviteVm.sendInviteWithCoCaptain,
                        "action": Util.SEND_INVITE
                    });
                    deferred.resolve();
                }).error(() => {
                    deferred.reject();
                });

            return deferred.promise;
        };

        sendInviteVm.dismiss = () => {
            $uibModalInstance.close({
                "user": sendInviteVm.user,
                "message": sendInviteVm.personalMsg,
                "action": Util.DO_IT_LATER
            });
        }

    }
}


angular.module('eCareVault.common.popUp')
    .controller('SendInviteController', SendInviteController);
